import { Injectable } from '@angular/core';
import { DpFieldButton, DpFieldText, DpFormRow, DpSection, DpSectionForm, DpSectionIcon } from '@docpath/webcomponents';
import { faCog } from '@fortawesome/free-solid-svg-icons';

@Injectable({
    providedIn: 'root'
})
export class AimFormService {

    getSectionForm(testClick: (fieldButton: DpFieldButton) => void): DpSectionForm {
        return new DpSectionForm({
            sections: [this.getAimSection(testClick)],
            i18nPrefix: 'services-config.aim.form',
            sectionIcon: new DpSectionIcon(faCog)
        });
    }

    private getAimSection(testClick: (fieldButton: DpFieldButton) => void): DpSection {
        return new DpSection({
            name: 'aim',
            rows: [
                new DpFormRow([
                    new DpFieldText({ name: 'url', required: true, column: 3, labelColumn: 2 }),
                    new DpFieldText({ name: 'appToken', required: true, column: 3, labelColumn: 1 }),
                    new DpFieldButton({ name: 'test', click: testClick, stateIcons: true, labelHidden: true, column: 3 })
                ])
            ]
        });
    }

}
